/**
 * Константы для событий из лингвы
 */

export default Object.freeze({
  SCREEN_READY: 'SCREEN_READY',
  USER_REPLIC: 'USER_REPLIC',
  ACTION_OPEN_MODAL_TICKETS: 'ACTION_OPEN_MODAL_TICKETS',
  ACTION_OPEN_MODAL_RULES: 'ACTION_OPEN_MODAL_RULES',
  ACTION_OPEN_MODAL_TERMS: 'ACTION_OPEN_MODAL_TERMS',
  ACTION_CONFIRM_CART_CLEAN: 'ACTION_CONFIRM_CART_CLEAN',
  ACTION_CANCEL_CART_CLEAN: 'ACTION_CANCEL_CART_CLEAN',
  ACTION_SEND_TICKET: 'ACTION_SEND_TICKET',
  ACTION_SEND_AUDIO: 'ACTION_SEND_AUDIO',
  ACTION_SEND_VIDEO: 'ACTION_SEND_VIDEO',
  ACTION_OPEN_MODAL_CONFIRM_VIDEO_RECORDING: 'ACTION_OPEN_MODAL_CONFIRM_VIDEO_RECORDING',
  ACTION_RETRY_TERMINAL_CONNECTION: 'ACTION_RETRY_TERMINAL_CONNECTION',
  ACTION_RETRY_PAY: 'ACTION_RETRY_PAY',
  ACTION_ENTERTAINMENT_PHOTO: 'ENTERTAINMENT_PHOTO',
  ACTION_SCORE_BAD: 'ACTION_SCORE_BAD',
  ACTION_SCORE_GOOD: 'ACTION_SCORE_GOOD',
  ACTION_SCORE_PERFECT: 'ACTION_SCORE_PERFECT',
  ACTION_PLAY: 'ACTION_PLAY',
  ACTION_OPEN_CONFIRM_MODAL: 'ACTION_OPEN_CONFIRM_MODAL',
  ACTION_TAKE_PHOTO: 'ACTION_TAKE_PHOTO',
  ACTION_REMAKE: 'ACTION_REMAKE',
  ACTION_PRINT: 'ACTION_PRINT',
  ACTION_CANCEL: 'ACTION_CANCEL',
  ACTION_SUBMIT: 'ACTION_SUBMIT',
  ACTION_CONTINUE: 'ACTION_CONTINUE',
  ACTION_RETRY: 'ACTION_RETRY',
  ACTION_BACK: 'ACTION_BACK',
  ACTION_MORE: 'ACTION_MORE',
  ACTION_PICK: 'ACTION_PICK',
  ACTION_SLIDE_PREV: 'ACTION_SLIDE_PREV',
  ACTION_SLIDE_NEXT: 'ACTION_SLIDE_NEXT',
  ACTION_SHOW_PHOTO_FRAMES: 'ACTION_SHOW_PHOTO_FRAMES',
  ACTION_SCROLL_UP: 'ACTION_SCROLL_UP',
  ACTION_SCROLL_DOWN: 'ACTION_SCROLL_DOWN',
  ACTION_VOLUME_UP: 'ACTION_VOLUME_UP',
  ACTION_VOLUME_DOWN: 'ACTION_VOLUME_DOWN',
  ACTION_CLEAR_SEARCH_NAME: 'ACTION_CLEAR_SEARCH_NAME',
  ACTION_CLEAR_SEARCH_DATE: 'ACTION_CLEAR_SEARCH_DATE',
  ACTION_CLEAR_SEARCH_TIME: 'ACTION_CLEAR_SEARCH_TIME',
  ACTION_CLEAR_SEARCH: 'ACTION_CLEAR_SEARCH',
  STEP_TERMINAL_ERROR: 'TERMINAL_ERROR',
  STEP_PAY_ERROR: 'PAY_ERROR',
  STEP_PAY_SUCCESS: 'PAY_SUCCESS',
  STEP_FETCH_EVENTS_ERROR: 'FETCH_EVENTS_ERROR',
  STEP_MODAL_CHOOSE_SEAT: 'MODAL_CHOOSE_SEAT',
  STEP_CONFIRM_CHOOSE_SEAT: 'CONFIRM_CHOOSE_SEAT',
  STEP_MODAL_CONFIRM_CART_CLEAN: 'MODAL_CONFIRM_CART_CLEAN',
  STEP_MODAL_TERMS: 'MODAL_TERMS',
  STEP_MODAL_RULES: 'MODAL_RULES',
  STEP_AUDIO_FEEDBACK_SUCCESS: 'AUDIO_FEEDBACK_SUCCESS',
  STEP_VIDEO_FEEDBACK_SUCCESS: 'VIDEO_FEEDBACK_SUCCESS',
  STEP_MODAL_CONFIRM_VIDEO_RECORDING: 'MODAL_CONFIRM_VIDEO_RECORDING',
  STEP_MODAL_CONFIRM_VIDEO_ABORT: 'MODAL_CONFIRM_VIDEO_ABORT',
  STEP_MODAL_CONFIRM_AUDIO_ABORT: 'MODAL_CONFIRM_AUDIO_ABORT',
  STEP_VIDEO_RECORD_IS_READY: 'VIDEO_RECORD_IS_READY',
  STEP_AUDIO_RECORD_IS_READY: 'AUDIO_RECORD_IS_READY',
  STEP_PHOTO_ACTION_ONE: 'PHOTO_ACTION_FIRST_STEP',
  STEP_PHOTO_ACTION_TWO: 'PHOTO_ACTION_SECOND_STEP',
  STEP_START: 'STEP_START',
  STEP_BUY_NOT_POSSIBLE: 'BUY_NOT_POSSIBLE',
});
